import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: auto;
    padding: 0 0 16px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 16px 32px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 760px) {
        padding: 16px;
    }
`;

export const ContainerFilters = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    >div:nth-of-type(1), 
    >div:nth-of-type(2) {
        max-width: 220px;
        height: auto !important;
    }

    @media (max-width: 1024px) {
        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 300px;
        }

        >div:nth-of-type(3) {
            width: 7.5rem;
        } 
    }

    @media (max-width: 760px) {
        gap: 8px;

        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 160px;
        }

        >div:nth-of-type(3) {
            width: auto;
        } 

        >div:nth-of-type(4) {
            width: 7.5rem;
        } 
    }

      @media (max-width: 360px) {
        >div:nth-of-type(1), 
        >div:nth-of-type(2) {
            max-width: 80%;
        }
    }
`;